import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(...inputs));
}

export function getRoomPath(room) {
  if (!room) return '/';
  const id = room.slug || room.id;
  const type = room.type?.toLowerCase();
  if (type === 'poll') return `/rm/pl/${id}`;
  if (type === 'brainstorm' || type === 'brainstorming') return `/rm/bs/${id}`;
  if (type === 'live' || type === 'mixed') return `/rm/${id}`;
  return `/rm/lv/${id}`;
}

export function getCommunityPath(community) {
  if (!community) return '/';
  const id = community.slug || community.id;
  return `/c/${id}`;
}

export function getDiscussionPath(discussion) {
  if (!discussion) return '/';
  const id = discussion.slug || discussion.id;
  return `/d/${id}`;
}

export const formatTime = (seconds) => {
  if (isNaN(seconds) || seconds < 0) return '0:00';
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  
  if (hrs > 0) {
    return `${hrs}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  }
  return `${mins}:${secs.toString().padStart(2, '0')}`;
};

export const getDurationInSeconds = (durationStr) => {
  if (!durationStr) return 0;
  const match = durationStr.match(/^(\d+)([mh])$/);
  if (!match) return 0;
  const value = parseInt(match[1]);
  const unit = match[2];
  return unit === 'h' ? value * 3600 : value * 60;
};

export const normalizeSpeaker = (candidate) => {
  if (candidate === undefined || candidate === null) return '';
  if (typeof candidate === 'string') return candidate.trim();
  if (typeof candidate === 'object') {
    const value = candidate.name || candidate.full_name || candidate.label || candidate.value || candidate.username || candidate.user_name || candidate.id || candidate.user_id;
    return value === undefined || value === null ? '' : String(value).trim();
  }
  return String(candidate).trim();
};

export const normalizeSpeakers = (candidates) => {
  if (!Array.isArray(candidates)) return [];
  return candidates.map(normalizeSpeaker).filter(Boolean);
};
